import { createTheme } from '@one-thd/sui-atomic-components';

const RWBPrimaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

RWBPrimaryTwo.palette['--sui-palette-background-primary'] = '39 47 73';
RWBPrimaryTwo.palette['--sui-palette-button-background-primary'] = '255 255 255';
RWBPrimaryTwo.palette['--sui-palette-text-primary'] = '255 255 255';
RWBPrimaryTwo.palette['--sui-palette-text-subtle'] = '255 255 255';

export { RWBPrimaryTwo };